import LucideIcon from '@/components/ui/LucideIcon';
import { Flex } from '@chakra-ui/react';
import type { ComponentProps } from 'react';
import React from 'react';

const WISHLIST_BUTTON_TEST_ID = 'wishlist-button';

type WishListButtonProps = ComponentProps<typeof Flex>;

const WishListButton = ({ ...rest }: WishListButtonProps) => {
  return (
    <Flex
      as="button"
      asChild
      cursor="pointer"
      data-testid={WISHLIST_BUTTON_TEST_ID}
      display={{ base: 'none', tablet: 'block' }}
      minWidth="28px"
      {...rest}
    >
      <LucideIcon height="28px" name="Heart" strokeWidth={1} width="28px" />
    </Flex>
  );
};

export default WishListButton;
